export default __webpack_public_path__ + "static/media/service-2-polishing.4e40c05b.png";